import { register } from "async-ops";
import { callMdaePublicApi } from "../../../call-web-api";
export const GET_DOCUMENTS = "GET_DOCUMENTS";


export const service = async (data) => {
  if(data.isManagerView){
  const options: object = {
    url: '/Api/Document/GetDocumentsForManagerView',
    type: "POST",
    contentType: 'application/json',
    isRoutedApiCall: true,
    body: JSON.stringify({...data})
  }
  const response = callMdaePublicApi(options);
  return response;
}else{
  const options: object = {
    url: '/private/v1/documents',
    type: "POST",
    contentType: 'application/json',
    body: JSON.stringify({
        ...data
    })
  }
  const response = callMdaePublicApi(options);
  return response;
}
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_DOCUMENTS, service, mock);
